module.exports = __webpack_public_path__ + "static/connect_01-8d845ade10a10cec46435045466ada39.png";